class UtilService {
  /**
   * Run a function on a debounce to avoid running a function multiple times needlessly
   */
  debounce (fn, milliseconds = 100) {
    let timer
    return function (...args) {
      if (timer) clearTimeout(timer)
      timer = setTimeout(() => fn(...args), milliseconds)
    }
  }
}

export const utilService = new UtilService()
